import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
// import MobileCustomCard from "./MobileCustomCard";
import Img1 from "./priya.png";
import Img2 from "./ravi.png";
import Img3 from "./shivani.png";
import MobileCardComponent from "../Section8/MobileCardComponent";
import MobileTeamComponent from "../Section8/MobileTeamComponent";
// import NewCustomCard from "../../Header/NewCustomCard";

const OurTeamMobile = () => {
  // Dummy Data for 12 Cards
  const testimonials = [
    {
      card_id: "1",
      name: "Priya Ostwal",
      position: "Marketing Manager",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism.",
      image: Img1, // Replace with actual image URL
    },
    {
      card_id: "2",
      name: "Akash Jain",
      position: "Business Executive, Cosco",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism. ",
      image: Img2, // Replace with actual image URL
    },
    {
      card_id: "3",
      name: "Achina Mayya",
      position: "Founder & CEO, AveyTV",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism.",
      image: Img3, // Replace with actual image URL
    },
    {
      card_id: "4",
      name: "Priya Ostwal",
      position: "Marketing Manager",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism.",
      image: Img1, // Replace with actual image URL
    },

    {
      card_id: "5",
      name: "Priya Ostwal",
      position: "Marketing Manager",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism.",
      image: Img1, // Replace with actual image URL
    },

    {
      card_id: "6",
      name: "Priya Ostwal",
      position: "Marketing Manager",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism.",
      image: Img1, // Replace with actual image URL
    },
    {
      card_id: "7",
      name: "Akash Jain",
      position: "Business Executive, Cosco",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism. ",
      image: Img2, // Replace with actual image URL
    },
    {
      card_id: "8",
      name: "Achina Mayya",
      position: "Founder & CEO, AveyTV",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism.",
      image: Img3, // Replace with actual image URL
    },
    {
      card_id: "9",
      name: "Priya Ostwal",
      position: "Marketing Manager",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism.",
      image: Img1, // Replace with actual image URL
    },

    {
      card_id: "10",
      name: "Priya Ostwal",
      position: "Marketing Manager",
      feedback:
        "Company has shown exceptional professionalism,professionalism.Company has shown exceptional professionalism,professionalism.",
      image: Img1, // Replace with actual image URL
    },
  ];

  // const scrollRef = useRef(null);
  // const [centerIndex, setCenterIndex] = useState(0);

  // // Scroll detection to highlight center card
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const container = scrollRef.current;
  //     if (!container) return;

  //     const containerCenter = container.scrollLeft + container.offsetWidth / 2;
  //     const cards = Array.from(container.children);

  //     let closestIndex = 0;
  //     let closestDistance = Infinity;

  //     cards.forEach((card, index) => {
  //       const cardCenter = card.offsetLeft + card.offsetWidth / 2;
  //       const distance = Math.abs(containerCenter - cardCenter);
  //       if (distance < closestDistance) {
  //         closestDistance = distance;
  //         closestIndex = index;
  //       }
  //     });

  //     setCenterIndex(closestIndex);
  //   };

  //   const container = scrollRef.current;
  //   container.addEventListener("scroll", handleScroll);
  //   handleScroll(); // Trigger on mount

  //   return () => container.removeEventListener("scroll", handleScroll);
  // }, []);

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        overflowX: "auto",
        "&::-webkit-scrollbar": {
          display: "none", // Hides scrollbar for WebKit browsers like Chrome, Safari
        },
        "-ms-overflow-style": "none", // Hides scrollbar for IE and Edge
        "scrollbar-width": "none", // Hides scrollbar for Firefox
        // border: "1px solid red",
        marginBottom: "40px",
      }}
    >
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack
          sx={{
            width: { xl: "73%", lg: "85%", md: "95%", sm: "96%", xs: "94%" },
            display: "flex",
            flexDirection: "column",
            // border: "1px solid red",
            marginBottom: "28px",
            //   gap: 2,
          }}
        >
          {/* <Typography
            variant="h5"
            sx={{
              lineHeight: {
                lg: "48px",
                xl: "48px",
                md: "32px",
                xs: "24px",
                sm: "24px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "40px",
                xl: "40px",
                md: "28px",
                xs: "20px",
                sm: "20px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 600,
                xl: 600,
                xs: 600,
                sm: 600,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
            }}
          >
            Our Team
          </Typography> */}
          <Stack
            sx={{
              fontFamily: "'Roboto', sans-serif",
              // border: "1px solid red",
              fontSize: {
                xs: "20px",
                sm: "24px",
                md: "24px",
                lg: "30px",
                xl: "30px",
              },
              lineHeight: {
                xs: "28px",
                sm: "36px",
                md: "32px",
                lg: "52px",
                xl: "52px",
              },
              fontWeight: 600,
              color: "rgb(5 78 146)",
              textAlign: "center",
              marginBottom: {
                xs: "20px",
                sm: "20px",
                md: "20px",
                lg: "20px",
                xl: "20px",
              },
              marginTop: {
                xs: "4px",
                sm: "16px",
                md: "40px",
                lg: "64px",
                xl: "64px",
              },

              // border: "1px solid red",
              display: { xs: "flex", sm: "none" },
              flexDirection: "row",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "6px", lg: "6px", xs: "4px" },
                  // height: { xl: "100%", lg: "100%", xs: "100%" },
                  height: {
                    xs: "20px",
                    sm: "44px",
                    md: "28px",
                    lg: "40px",
                    xl: "40px",
                  },
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  border: "1px solid rgb(5 78 146)",
                  // backgroundColor: "rgb(5 78 146)",
                  backgroundColor: "rgb(5 78 146)",
                  marginRight: {
                    xs: "8px",
                    sm: "8px",
                    md: "12px",
                    lg: "12px",
                    xl: "12px",
                  },
                  borderTopRightRadius: "8px", // Adjust the value as needed
                  borderBottomRightRadius: "8px", // Adjust the value as needed
                }}
              >
                <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
              </Stack>
            </Stack>
            <span style={{ display: "inline-flex", alignItems: "center", color: "rgb(5, 78, 146)", }}>
              Our Team 👩‍💻
            </span>
          </Stack>
          <Typography
            variant="body1"
            sx={{
              lineHeight: {
                lg: '32px',
                xl: '32px',
                md: '20px',
                xs: '20px',
                sm: '20px',
              },
              fontSize: {
                lg: "20px",
                xl: "20px",
                md: "18px",
                xs: "16px",
                sm: "18px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: '#333',
              borderRadius: '8px',
              display: {
                xl: 'flex',
                lg: 'flex',
                md: 'flex',
                sm: 'flex',
                xs: 'flex',
              },
              marginBottom: { xs: '28px', sm: '0px' },
              // textAlign: 'justify',
            }}
          >
            We’re a passionate team of developers, designers, and strategists united by a shared mission-to
            create impactful digital experiences and drive innovation forward.
          </Typography>
        </Stack>
      </Stack>

      <MobileTeamComponent />
      {/* <MobileCardComponent /> */}
    </Stack>
  );
};

export default OurTeamMobile;
